//  React TS Base Styles
import typography from '../../base/typography'
import colors from '../../base/colors'

const { size } = typography
const { text } = colors

// types
type Types = any

const dialogContentText: Types = {
  styleOverrides: {
    root: {
      fontSize: size.md,
      color: text.main,
    },
  },
}

export default dialogContentText
